import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import Login from '../views/Login.vue';
import Agenda from '../views/Agenda.vue';
import Live from '../views/Live.vue';
import Sponsors from '../views/Sponsors.vue';
import Stand from '../views/Stand.vue';
import Certificate from '../views/Certificate.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/agenda',
    name: 'Agenda',
    component: Agenda,
  },
  {
    path: '/sponsors',
    name: 'Sponsors',
    component: Sponsors,
  },
  {
    path: '/live',
    name: 'Live',
    component: Live,
    beforeEnter: (to, from, next) => {
      console.log(to, from);
      next('/');
    },
  },
  {
    path: '/live/:id',
    name: 'Live',
    component: Live,
  },
  {
    path: '/stand',
    name: 'Stand',
    component: Stand,
  },
  {
    path: '/certificate',
    name: 'Certificate',
    component: Certificate,
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
